window.onscroll = function() { scrollFunction() };

function scrollFunction() {
    var scrollToTopBtn = document.getElementById("scrollToTopBtn");
    if (document.body.scrollTop > 750 || document.documentElement.scrollTop > 750) {
        scrollToTopBtn.classList.add("show");
        scrollToTopBtn.classList.remove("hide");
    } else {
        scrollToTopBtn.classList.add("hide");
        scrollToTopBtn.classList.remove("show");
    }
}

function scrollToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}


// Hero scroll
document.addEventListener("DOMContentLoaded", function() {
    const scrollLinks = document.querySelectorAll("#scrollLink, #scrollLink2");

    scrollLinks.forEach(function(scrollLink) {
        scrollLink.addEventListener("click", function(event) {
            event.preventDefault();

            const targetElement = document.getElementById("kundrecensioner");
            const targetPosition = targetElement.getBoundingClientRect().top;
            const offset = 100;

            window.scrollTo({
                top: targetPosition + window.scrollY - offset,
                behavior: "smooth"
            });
        });
    });
});

//# sourceMappingURL=scroll-to-top.js.map
